<template>
<div class="chapter">
<div class="inner_page">
<div id="ur7J8G4dt7t2HBVxGfLG2wG">
<p class="ORIM-Chapter-Title-Page-Break--Body-" id="uExdYivCbuBSC4csbFGEFWD">I</p>
<p class="part _idGenParaOverride-1"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlmostDark5.vue?9e3e7cca